<template>
  <div>
    <AlterFormLayout
      modalId="add-temporary-assistance-modal"
      formTitle="Solicitar auxílio"
      cancelButtonText="Cancelar"
      submitButtonText="Enviar solicitação de auxílio"
      :onSubmitEvent="onSubmit"
      :disableEvent="this.$store.getters.isAdmin"
    >
      <template #content>
        <TemporaryAssistanceForm />
      </template>
    </AlterFormLayout>
    <success-modal
      ref="success-modal"
      description="Olá Cooperado(a), acusamos o recebimento de sua solicitação e as tratativas estão em andamento."
      buttonText="Ok, entendi!"
      subdescription="Em breve retornaremos."
      :protocol="this.protocol"
    />
  </div>
</template>

<script>
import TemporaryAssistanceForm from "./TemporaryAssistanceForm.vue";
import AlterFormLayout from "../../../../layouts/AlterFormLayout.vue";
import SuccessModal from "../../../../components/base-modals/SuccessModal.vue";
import { addTemporaryAssistance } from "../../../../services/temporary-assistance/temporary-assistance-service";

export default {
  components: {
    AlterFormLayout,
    TemporaryAssistanceForm,
    SuccessModal,
  },
  data() {
    return {
      protocol: "",
    };
  },
  methods: {
    async onSubmit(formData) {
      formData.name = "Solicitação de Auxílio Temporário";
      this.protocol = await addTemporaryAssistance(formData, formData.files);
      const modal = this.$refs["success-modal"].$children[0];
      modal.show();
    },
  },
};
</script>
